/* eslint-disable class-methods-use-this */
import axios from 'axios';
import _ from 'lodash';

class Client {
    constructor() {
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
        axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE';

        const meta = document.head.querySelector('meta[name="csrf-token"]');
        if (meta) {
            axios.defaults.headers.common['X-CSRF-TOKEN'] = meta.content;
        }
        const token = localStorage.getItem('app_token') || '';
        axios.defaults.headers.common.Authorization = `Bearer ${token}`;
        this.http = axios.create({
            // baseURL: "/api",
            // baseURL: "http://127.0.0.1:8000/api",
            baseURL: "https://api.kodi.ke/api",
        });

        this.http.interceptors.response.use(response => response, async (error) => {
            if (error.response && error.response.data && error.response.data.blocked) {
                // EnsureBusinessNotBlocked (realtor-backend) re-checks
                // is_blocked on every authenticated request, not just at
                // login - a business can go from active to blocked while
                // someone's mid-session, so this has to be a global check
                // here too, not just the one in the login action. Checked
                // before the generic 401 branch below, since this can
                // itself arrive as a 401 (from the login flow) or a 403
                // (from this per-request check) and either way it means
                // "go pay your invoice", not "your session expired".
                if (!window.location.href.includes("unlock-account")) {
                    window.location.href = '/unlock-account/' + error.response.data.unlock_token;
                }
            } else if (error.response && error.response.data && error.response.data.disabled) {
                // A platform admin disabled this business (realtor-backend
                // EnsureBusinessNotBlocked) - unlike a block there's nothing to
                // pay, so sign out; logging in again shows the reason.
                localStorage.removeItem('app_token');
                if (!window.location.href.includes("auth")) {
                    window.location.href = '/auth';
                }
            } else if (error.response && error.response.status === 401) {
                localStorage.removeItem('app_token');
                if (!window.location.href.includes("auth") && !window.location.href.includes("register")) {
                    window.location.href = '/auth';
                }
            } else if (error.response && error.response.status === 403 && error.response.data && error.response.data.plan_limit_exceeded) {
                // PlanLimitExceededException::render() (realtor-backend) - a plan
                // limit can be hit from any request, not just at login, so this is
                // a global check (unlike the blocked-account 401 above, which is
                // only special-cased inside the login action). Stashed in
                // sessionStorage rather than committed to the store directly,
                // since importing the store singleton here would create the same
                // kind of circular import client.js -> store -> api -> client.js;
                // PlanLimit.vue reads it back on mount instead - same
                // decoupled-hard-redirect shape as the 401 branch above.
                sessionStorage.setItem('plan_limit_info', JSON.stringify(error.response.data));
                if (!window.location.href.includes("plan-limit")) {
                    window.location.href = '/plan-limit';
                }
            }
            return Promise.reject(error);
        });
    }

    // setHeader(key, value) {
    //     this.http.defaults.common.headers[key] = value;
    //     return this;
    // }

    // setToken(token) {
    //     this.setHeader('Authorization', `Bearer ${token}`);
    //     return this;
    // }

    get(path, params, config) {
        const sessionId = localStorage.getItem('session_property');

        // If session_id exists, append it to params
        if (sessionId) {
            params = {
                ...params,
                session_property: sessionId
            };
        }
        return this.http.get(path, {params, ...config});
    }

    post(path, data, config) {
        return this.http.post(path, data, config);
    }

    upload(path, data, file, config) {
        const form = new FormData();
        _.each(data, (value, key) => {
            form.append(key, value);
        });
        return this.post(path, form, {
            ...config,
            headers: {'Content-Type': 'multipart/form-data'},
        });
    }

    put(path, data, config) {
        return this.http.put(path, data, config);
    }

    delete(path, params, config) {
        return this.http.delete(path, {params, ...config});
    }

    parseResponse({data}) {
        return data;
    }
}

export default new Client();